export const DATA_PLATE_LIST= 'DATA_PLATE_LIST';
export const PLATE_EDIT_PIC = 'PLATE_EDIT_PIC';
export const ADD_REPLACE_DATE_PLATE = 'ADD_REPLACE_DATE_PLATE';
export const DELETE_PLATE_PICTURES= 'DELETE_PLATE_PICTURES';
export const DATA_PLATE_LOADER = 'DATA_PLATE_LOADER';
